const $ = window.jQuery;
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Swiper, { FreeMode, Scrollbar } from 'swiper';

class StringIdGenerator {
    constructor(chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') {
      this._chars = chars;
      this._nextId = [0];
    }
  
    next() {
      const r = [];
      for (const char of this._nextId) {
        r.unshift(this._chars[char]);
      }
      this._increment();
      return r.join('');
    }
  
    _increment() {
      for (let i = 0; i < this._nextId.length; i++) {
        const val = ++this._nextId[i];
        if (val >= this._chars.length) {
          this._nextId[i] = 0;
        } else {
          return;
        }
      }
      this._nextId.push(0);
    }
  
    *[Symbol.iterator]() {
      while (true) {
        yield this.next();
      }
    }
  }

const AfMap = {

    loader: new Loader({
        version: "weekly",
        libraries: ["places", "directions"]
    }),



    markers: [],

    map: [],

    bounds: [],

    directionsDisplay: [],

    markerInfoWindow: [],
    defaultCordinates: {
        lat: 62.29312766015773,
        lng: 15.633204825628782
    },
    hasPosPermission: false,
    imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",

    $afItemList: $('#af-list'),
    init() {
        const $map = $('#af-map');
        if (!$map.length)
            return;
        const afThis = this;

        this.loader.apiKey = google_api_key;
        // Callback
        this.loader.loadCallback(e => {
            if (e) {
                console.log(e);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        afThis.defaultCordinates = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        afThis.hasPosPermission = true;
                        $('.search-af-position').show();
                        window.initMap = afThis.initialiseMap();
                    }, function () {
                        afThis.hasPosPermission = false;
                        $('.search-af-position').hide();
                        window.initMap = afThis.initialiseMap();
                    });
                }

            }
        });


        // configure Swiper to use modules
        Swiper.use([Scrollbar, FreeMode]);

        /**
         * Swiper för scroll contianers i popupmoduler
         */
        const scrollSwiper = new Swiper(".af-scroll-swiper", {
            direction: 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
            observer: true,
            observeParents: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                hide: false,
                enabled: true
            },
        });



    },
    initialiseMap() {

        this.directionsService = new google.maps.DirectionsService;

/*         this.directionsDisplay = new google.maps.DirectionsRenderer({
            polylineOptions: {
                strokeColor: "red"
            }
        });
 */

        this.markerInfoWindow = new google.maps.InfoWindow({ content: "" });

        this.bounds = new google.maps.LatLngBounds();

        var myStyles = [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];

        this.map = new google.maps.Map(document.getElementById('af-map'), {
            zoom: 7,
            styles: myStyles,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

     //   this.directionsDisplay.setMap(this.map);

        this.setDefaultMapLocation();
        const afThis = this;


        $('.search-af-position').on('click', function () {

            // Try HTML5 geolocation.
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        afThis.defaultCordinates = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        afThis.hasPosPermission = true;
                        afThis.map.setCenter(afThis.defaultCordinates);
                        afThis.map.setZoom(10);

                        const infoTextEl = $('[data-list-info]');

                        const maxRadius = 10;

                        let foundItemWithinRadius = false;
                        $('#af-list li').each(function () {
                            const listLat = $(this).data('lat');
                            const listLng = $(this).data('lng');
                            // if this location is within 0.1KM of the user, add it to the list

                            if (afThis.filter_distance(afThis.defaultCordinates.lat, afThis.defaultCordinates.lng, listLat, listLng, "K") <= maxRadius) {
                                $(this).show();
                                foundItemWithinRadius = true;
                     
                                const distance = afThis.calcDistance(
                                    new google.maps.LatLng(afThis.defaultCordinates.lat, afThis.defaultCordinates.lng),
                                    new google.maps.LatLng(listLat, listLng)
                                );
                                console.log(`distance: ${distance}`);
                                $(this).find('.af-list__item__distance').text(`(${distance} km)`);
                                $(this).attr('data-distance', distance);
                            } else {
                                $(this).hide();
                                
                            }
                        });
                    
                        const sortIds = new StringIdGenerator();

                        if (foundItemWithinRadius) {
                            Array.from(document.querySelectorAll(`#af-list li:not([style="display: none;"])`))
                            .sort(({dataset: {distance: a}}, {dataset: {distance: b}}) => a.localeCompare(b)) // To reverse it, use `b.localeCompare(a)`.
                            .forEach((item) => {
                                item.parentNode.appendChild(item);
                            });

                            $('#af-list li:not([style="display: none;"])').each(function () {
                                const listItemSortIndicator =   $(this).find('.af-list__item__sortgroup');
                              
                                listItemSortIndicator.find('span').text(sortIds.next());
                                listItemSortIndicator.show()
                            });

                            infoTextEl.text(`Visar återförsäljare inom ${maxRadius}km`);
                           
                        } else {
                            infoTextEl.text(`Vi kunde inte hitta några återförsäljare inom 25km från din position.`);
                        }


                    },
                    () => {
                        afThis.handleLocationError(true, afThis.markerInfoWindow, afThis.map.getCenter());
                    }
                );
            } else {
                // Browser doesn't support Geolocation
                afThis.handleLocationError(false, afThis.markerInfoWindow, afThis.map.getCenter());
                afThis.setDefaultMapLocation();
            }


        });

        this.addMarkers();
    },
    calcDistance(p1, p2) {
        const d = (google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000).toFixed(2);
        return d;
    },

    filter_distance(lat1, lon1, lat2, lon2, unit) {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit == "K") { dist = dist * 1.609344 }
        if (unit == "N") { dist = dist * 0.8684 }
        return dist
    },
    addMarkers() {
        const testThis = this;
        for (let item of af_items) {


            const icon = {
                path: "M320.69 630.86C320.69 630.86 520.91 323.43 520.91 222.4C520.91 73.71 419.43 9.03 320.46 8.8C221.49 9.03 120 73.71 120 222.4C120 323.43 320.34 630.86 320.34 630.86C320.34 630.86 320.46 630.51 320.46 630.51C320.46 630.63 320.64 630.79 320.69 630.86ZM320.57 144.46C358.97 144.46 390.06 175.54 390.06 213.94C390.06 252.34 358.86 283.43 320.46 283.43C282.17 283.43 251.09 252.34 251.09 213.94C251.09 175.54 282.17 144.46 320.57 144.46Z", //SVG path of awesomefont marker
                fillColor: "#3C6F83", //color of the marker
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 0.06, //size of the marker, careful! this scale also affects anchor and labelOrigin
                anchor: new google.maps.Point(310, 620), //position of the icon, careful! this is affected by scale
                labelOrigin: new google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
            }


            const icon_base_url = theme_template_directory;

            const markerImage = new google.maps.MarkerImage(
                `${icon_base_url}/assets/img/map-icon.svg`,
                new google.maps.Size(15, 15), //size
                null, //origin
                null, //anchor
                new google.maps.Size(15, 15) //scale
            );



            let markerIcon = markerImage;


            const latLng = new google.maps.LatLng(item.lat, item.lng);

            const marker = new google.maps.Marker({
                position: latLng,
                map: testThis.map,
                category: item.postcode,
                title: item.name,
                icon: markerIcon,
            });


            // markers can only be keyboard focusable when they have click listeners
            // open info window when marker is clicked
            marker.addListener("click", () => {
                console.log(testThis.defaultCordinates.lat, testThis.defaultCordinates.lng);
                const distinationOrigin = new google.maps.LatLng(testThis.defaultCordinates.lat, testThis.defaultCordinates.lng);
                const destinationMarker = `${item.lat},${item.lng}`;
                testThis.calculateAndDisplayRoute(item, marker, testThis.directionsService, testThis.directionsDisplay, distinationOrigin, destinationMarker, testThis.markerInfoWindow);
            });

            testThis.markers.push(marker)
            //when the map zoom changes, resize the icon based on the zoom level so the marker covers the same geographic area
            google.maps.event.addListener(testThis.map, 'zoom_changed', function () {

                var pixelSizeAtZoom0 = 7; //the size of the icon at zoom level 0
                var maxPixelSize = 22; //restricts the maximum size of the icon, otherwise the browser will choke at higher zoom levels trying to scale an image to millions of pixels

                var zoom = testThis.map.getZoom();
                var relativePixelSize = Math.round(pixelSizeAtZoom0 * Math.pow(2, zoom)); // use 2 to the power of current zoom to calculate relative pixel size.  Base of exponent is 2 because relative size should double every time you zoom in

                if (relativePixelSize > maxPixelSize) //restrict the maximum size of the icon
                    relativePixelSize = maxPixelSize;

                //change the size of the icon
                marker.setIcon(
                    new google.maps.MarkerImage(
                        marker.getIcon().url, //marker's same icon graphic
                        null,//size
                        null,//origin
                        null, //anchor
                        new google.maps.Size(relativePixelSize, relativePixelSize) //changes the scale
                    )
                );
            });

        }

        this.drawMarkerCluster();

    },

    setInfoContent(item, totalDistance = null) {
        let html = "";

        html += `<h3 style="margin-top: 0; font-size: 22px;"><a href="">${item.name}</a></h3>`;
        html += `<a class="cta-link" target="_blank"  href="tel:${item.phone}">${item.phone}</a>`;
        html += `<a class="cta-link" target="_blank" href="mailto:${item.email}">${item.email}</a>`;
        html += `<p class="adress">${item.adress}, ${item.city} ${item.postcode} </p>`;

        if (totalDistance && this.hasPosPermission) {
            html += `<p class="distance">(${totalDistance} km)</p>`;
        }

        const link = this.generateAfLink(item);
        html += `<a class="webbadress" target="_blank" href="${link}">Kontakta återförsäljare</a>`;
        return html;
    },

    generateAfLink(item) {
        let link = "#";
        if (item.company === "Fonus") {
            const slug_name = this.slugify(item.city);
            link = `https://www.fonus.se/begravningsbyra/${slug_name}`;
        }
        if (item.company === "Fonus Öst") {
            const slug_name = this.slugify(item.city);
            link = `https://fonusost.se/vara-begravningsbyraer/fonus-ost-begravningsbyra-${slug_name}`;
        }
        if (item.company === "Lavendla") {
            link = `https://lavendla.se/om-lavendla/kontakta-oss/`;
        }
        if (item.company === "Momento") {
            link = `https://www.momentobyraerna.se/`;
        }
        if (item.company === "fondkistan") {
            const slug_name = this.slugify(item.city);
            link = `https://www.fondkistan.se/vara-kontor/${slug_name}`;
        }
        return link;
    },
    slugify(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáäåâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;";
        var to = "aaaaaeeeeiiiioooouuuuncescrzyuudtn------";

        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace('.', '-') // replace a dot by a dash 
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
            .replace(/-+/g, '-') // collapse dashes
            .replace(/\//g, ''); // collapse all forward-slashes

        return str;

    },
    handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? "Error: The Geolocation service failed."
                : "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(map);
    },
    getGoogleClusterInlineSvg(color) {
        const encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><defs><g id="a" transform="rotate(45)"><path d="M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z" fill-opacity="0.7"/><path d="M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z" fill-opacity="0.5"/><path d="M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.3"/></g></defs><g fill="' + color + '"><circle r="42"/><use xlink:href="#a"/><g transform="rotate(120)"><use xlink:href="#a"/></g><g transform="rotate(240)"><use xlink:href="#a"/></g></g></svg>');

        return ('data:image/svg+xml;base64,' + encoded);
    },
    drawMarkerCluster() {
        const markers = this.markers;
        const map = this.map;




        const afThis = this;



        const cluster_styles = [
            {
                width: 40,
                height: 40,
                url: afThis.getGoogleClusterInlineSvg('blue'),
                textColor: 'white',
                textSize: 12
            },
            {
                width: 50,
                height: 50,
                url: afThis.getGoogleClusterInlineSvg('violet'),
                textColor: 'white',
                textSize: 14
            },
            {
                width: 60,
                height: 60,
                url: afThis.getGoogleClusterInlineSvg('yellow'),
                textColor: 'white',
                textSize: 16
            }
            //up to 5
        ];

        // use default algorithm and renderer
        /*     const markerCluster = new MarkerClusterer({
                map, markers,
                styles: cluster_styles
            }); */


        let marker;
        // To add the marker to the map, call setMap();
        for (let i = 0; i < markers.length; i++) {
            marker = markers[i];

            marker.setMap(afThis.map);
        }



        $('#search-af').on('submit', function (e) {
            e.preventDefault();
            const postcode = $(this).find('#postnummer').val();
            let short_postcode = postcode;
            if(postcode.length > 3) {
                short_postcode = postcode.substring(0, 3);
            }
            let marker;
            let filteredMarkers = [];
            let listItem;
           
            const infoTextEl = $('[data-list-info]');

            let itemsFound = false;
            for (let i = 0; i < markers.length; i++) {
                marker = markers[i];
                listItem =   $('#af-list').find(`[data-title="${marker.title}"]`);
                if ((marker.category === postcode) || marker.category.startsWith(short_postcode)) {
                    itemsFound = true;
                    filteredMarkers.push(marker);
                    marker.setVisible(true);
                    const listLat = listItem.data('lat');
                    const listLng = listItem.data('lng');
                    // if this location is within 0.1KM of the user, add it to the list
                    const distance = afThis.calcDistance(
                        new google.maps.LatLng(afThis.defaultCordinates.lat, afThis.defaultCordinates.lng),
                        new google.maps.LatLng(listLat, listLng)
                    );
                    console.log(`distance: ${distance}`);
                    listItem.find('.af-list__item__distance').text(`(${distance} km)`);
                    listItem.attr('data-distance', distance);
                    listItem.show();
                        
                } else {
                    marker.setVisible(false);
                    listItem.hide();
                }
            }

            const sortIds = new StringIdGenerator();

            if (itemsFound) {
                Array.from(document.querySelectorAll(`#af-list li:not([style="display: none;"])`))
                .sort(({dataset: {distance: a}}, {dataset: {distance: b}}) => a.localeCompare(b)) // To reverse it, use `b.localeCompare(a)`.
                .forEach((item) => {
                    item.parentNode.appendChild(item);
                });

                $('#af-list li:not([style="display: none;"])').each(function () {
                    const listItemSortIndicator =   $(this).find('.af-list__item__sortgroup');
                    listItemSortIndicator.find('span').text(sortIds.next());
                    listItemSortIndicator.show()
                }); 
                if(postcode) {
                    infoTextEl.text(`Hittade ${filteredMarkers.length} återförsäljare nära ${postcode}`);
                } else {
                    infoTextEl.text(`${filteredMarkers.length} återförsäljare`);
                }
             
                infoTextEl.show();
            } else {
                // infoTextEl.text('Inga återförsäljare inom 100km');
                infoTextEl.hide();
            }


/* 
           

     
        
           
 */
       
            afThis.setDefaultMapLocation();
            return false;
        });

    },
    setDefaultMapLocation() {
        const afThis = this;

        this.map.setCenter(new google.maps.LatLng(afThis.defaultCordinates.lat, afThis.defaultCordinates.lng));
    },
    computeTotals(item, marker, result, infowindow) {
        const afThis = this;
        var totalDist = 0;
        var totalTime = 0;
        var myroute = result.routes[0];
        for (var i = 0; i < myroute.legs.length; i++) {
            totalDist += myroute.legs[i].distance.value;
            totalTime += myroute.legs[i].duration.value;
        }
        totalDist = totalDist / 1000.
        const totalDistance = totalDist.toFixed(2);
        infowindow.setContent(afThis.setInfoContent(item, totalDistance));
        infowindow.open(afThis.map, marker);
    },

    calculateAndDisplayRoute(item, marker, directionsService, directionsDisplay, distinationOrigin, destinationMarker, infowindow) {
        const afThis = this;
        directionsService.route({
            origin: distinationOrigin,
            destination: destinationMarker,
            travelMode: google.maps.TravelMode.DRIVING
        }, function (response, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                /*    directionsDisplay.setDirections(response); */
                afThis.computeTotals(item, marker, response, infowindow);
            } else {
                window.alert('Directions request failed due to ' + status);
            }
        });
    }
};

export default AfMap;